/* eslint-disable */

import jQuery from "jquery"

// I believe this comes from https://benalman.com/projects/jquery-throttle-debounce-plugin/

// Example Usage:
//     function log( event ) { console.log( $(window).scrollTop(), event.timeStamp ); };[:w
//     $(window).scroll( $.throttle( 250, log ) );

// Note: All coffeescript code is deprecated

// Generated by CoffeeScript 2.5.1
(function(window, $) {
  // coffeelint: disable=max_line_length
  return (function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){console.error("Do not use jQuery.throttle");var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);;
// coffeelint: enable=max_line_length
}).call(globalThis, window, jQuery);
